import { WorkflowId } from '../../core/Enums';
import type { TourDefinition } from '../../core/Types';
import { seedModel } from '../../data/Seed';
import { paymentsSteps } from './Steps';

export const paymentsTour: TourDefinition = {
  id: WorkflowId.PAYMENTS,
  title: 'Payments Tour',
  steps: paymentsSteps,
  initialModel: seedModel(),
};
